export default __webpack_public_path__ + "static/media/poster5.9ac33bbb.jpg";